/* BackupDetailComponent.js */

"use strict";

const Renderer = require("./BackupDetailRenderer");
const EventEmitter = require("events").EventEmitter;
const ScheduleVeilComponent = require("../../../../../../lib/actions/veils/schedule/ScheduleVeilComponent");
const _ = require("lodash");

class BackupDetailComponent extends EventEmitter {
    constructor(logger, GameEditor) {
        super(logger, GameEditor);
        this._gameEditor = GameEditor;
        this._title = "Backup Device";
        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        return this._renderer
            .shutdown()
            .then(() => {
                this._title = this._renderer = this._context = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "BaseCreateComponent.shutdown() error");
            });
    }

    backupAction(name, runCapture) {
        this._context.resolve({name, runCapture});
    }

    scheduleExport(scheduleName, workInput) {
        const activeOrgId = _.get(this._gameEditor._activeView, "_gameEditor._activeOrgId");
        const workTarget = {
            method: "multi",
            category: "entity",
            entityType: "Device",
            ids: [this._gameEditor._selectedDeviceIds],
        };
        const titleMsg = "Schedule Backup";

        return this._gameEditor._modalUserFeedback
            .displayCustom(
                new ScheduleVeilComponent(this._logger, true, titleMsg, {
                    workType: "backup",
                    soln: undefined,
                    selectedRowsCount: 1,
                }),
                {dontHide: false}
            )
            .then((scheduleDef) => {
                let schedule = scheduleDef.schedule;

                // For PE-10982 - to add the notification settings on workInput
                Object.assign(workInput, scheduleDef.workInput);

                // backdoor to allow every minute schedules for internal testing
                if (_.get(schedule, "every.hour") && name === "everymin") {
                    _.set(schedule, "every.minute", schedule.every.hour);
                    delete schedule.every.hour;
                }

                this._gameEditor._deviceEntity.scheduleBackupWork(
                    activeOrgId,
                    scheduleName,
                    "",
                    schedule,
                    workTarget,
                    workInput
                );

                return Promise.resolve();
            })
            .catch((err) => Promise.reject(err));
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    set "$teve.ui.context"(context) {
        this._context = context;
    }
}

module.exports = BackupDetailComponent;
